import instance from "../../shared/utils/instance";

export const getCampaignInfoApi = invitationId =>
  instance
    .get(`invitations/campaign/${invitationId}`)
    .then(response => response.data);
